<template>
  <div id="app">
    <PhotoBooth />
  </div>
</template>

<script setup>
import PhotoBooth from './components/PhotoBooth.vue'
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  background: #0a0a0a;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'SF Pro Display', 'Helvetica Neue', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  padding: 12px;
}
</style>
